import Vue from 'vue'
import Vuex from 'vuex'

import user from './module/user'
import jianianhua from './module/jianianhua'
import lottery from './module/lottery'
// import sys from './module/sys'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
  },
  mutations: {

  },
  actions: {
  },
  modules: {
    user,
    jianianhua,
    lottery
    // sys
  }
})
